import { CapacityPlanRunStatus } from 'core/graphql/types';

export interface RunStatusBadgeProps {
  status: CapacityPlanRunStatus;
  /** Failed Solves of a Computed run; zero leaves the badge as a plain success. */
  failedSolves?: number;
}

const colours: { [key in CapacityPlanRunStatus]: string } = {
  [CapacityPlanRunStatus.Created]: 'bg-gray text-design-black',
  [CapacityPlanRunStatus.Queued]: 'bg-gray text-design-black',
  [CapacityPlanRunStatus.Computing]: 'bg-yellow text-design-black',
  [CapacityPlanRunStatus.Computed]: 'bg-design-green text-design-black',
  [CapacityPlanRunStatus.Failed]: 'bg-darker-red text-white',
};

const RunStatusBadge = ({
  status,
  failedSolves = 0,
}: RunStatusBadgeProps) => {
  const completedWithFailures =
    status === CapacityPlanRunStatus.Computed && failedSolves > 0;

  return (
    <span
      className={`rounded-sm px-2 py-1 text-xs font-semibold uppercase tracking-wide ${
        completedWithFailures
          ? 'bg-yellow text-design-black'
          : colours[status]
      }`}
    >
      {completedWithFailures ? `${status} · ${failedSolves} failed` : status}
    </span>
  );
};

export default RunStatusBadge;
